import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, MessageCircle, X, Send } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingActions: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleStartChat = () => {
    const message = encodeURIComponent(t('footer.whatsapp_msg'));
    window.open(`https://wa.me/85251208911?text=${message}`, '_blank');
  };

  const hideShop = location.pathname.startsWith('/products') || location.pathname.startsWith('/checkout');

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col items-end">
      <AnimatePresence>
        {isChatOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="mb-4 w-72 bg-brand-paper shadow-2xl border border-brand-ink/5 overflow-hidden"
          >
            <div className="bg-[#25D366] p-4 flex justify-between items-center">
              <div className="flex items-center gap-2 text-white">
                <MessageCircle className="w-5 h-5" />
                <span className="font-serif text-sm">{t('brand.name')} · WhatsApp</span>
              </div>
              <button onClick={() => setIsChatOpen(false)} className="text-white/80 hover:text-white">
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-6">
              <p className="text-xs text-brand-ink/60 font-sans mb-6 leading-relaxed">
                {t('footer.whatsapp_msg')}
              </p>
              <button
                onClick={handleStartChat}
                className="w-full py-3 bg-brand-ink text-brand-paper text-xs font-sans tracking-widest flex items-center justify-center gap-2 hover:bg-brand-charcoal transition-colors"
              >
                <Send className="w-3 h-3" />
                WhatsApp
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.6 }}
        className="flex items-center overflow-hidden rounded-full shadow-[0_4px_16px_rgba(0,0,0,0.2)]"
      >
        {!hideShop && (
          <Link
            to="/products"
            className="flex items-center justify-center gap-1.5 h-11 pl-4 pr-5 bg-brand-cinnabar text-brand-paper hover:bg-brand-crimson transition-colors"
            aria-label="前往選購產品"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="font-sans text-[13px] tracking-widest">選購</span>
          </Link>
        )}
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => setIsChatOpen(!isChatOpen)}
          className={`flex items-center justify-center h-11 w-11 bg-[#25D366] text-white hover:bg-[#1ebe5b] transition-colors ${hideShop ? 'rounded-full' : 'rounded-r-full'}`}
          aria-label={isChatOpen ? '關閉 WhatsApp' : '開啟 WhatsApp'}
        >
          {isChatOpen ? <X className="w-5 h-5" /> : <MessageCircle className="w-5 h-5" />}
        </motion.button>
      </motion.div>
    </div>
  );
};

export default FloatingActions;
